export default {
  // Navigation
  nav_categories: "Kategorier",
  nav_guides: "Guides",
  nav_reviews: "Anmeldelser",
  nav_shipping: "Forsendelse",
  nav_about: "Om",
  nav_contact: "Kontakt",
  nav_language: "Sprog",

  // Hero Section
  hero_h1: "AllChinaBuy Spreadsheet — Find produkter, sammenlign muligheder og shop klogere",
  hero_subtitle: "Udforsk AllChinaBuy spreadsheet-ressourcer, produktfund, QC-guides, forsendelsesinformation, anmeldelser og sammenligninger — organiseret i et nemt at bruge ressourcecenter.",
  hero_cta_primary: "Udforsk AllChinaBuy Spreadsheet",
  hero_cta_secondary: "Køb nu",
  hero_search_placeholder: "Søg AllChinaBuy spreadsheet, produkter, forsendelse, QC eller guides...",

  // Category Section
  categories_title: "Populære kategorier",
  categories_subtitle: "Gennemse vores udvalgte produktkategorier og find de bedste tilbud på AllChinaBuy",
  category_shoes: "Sko",
  category_hoodies: "Hættetrøjer / Sweatere",
  category_tshirts: "T-Shirts",
  category_jackets: "Jakker",
  category_pants: "Bukser / Shorts",
  category_headwear: "Hovedbeklædning",
  category_sets: "Sæt",
  category_underwear: "Undertøj",
  category_jersey: "Trøjer",
  category_accessories: "Tilbehør",
  category_bags: "Tasker",
  category_belts: "Bælter",
  category_perfumes: "Parfumer",
  category_other: "Andet",
  category_button: "Gennemse alle",

  // Articles Section
  articles_title: "Seneste guides og ressourcer",
  articles_subtitle: "Indgående artikler til at hjælpe dig med at shoppe klogere på AllChinaBuy",
  article_read_more: "Læs guide",
  article_read_time: "min læsning",
  article_allchinabuy_spreadsheet_guide: "Komplet guide til AllChinaBuy Spreadsheet",
  article_allchinabuy_spreadsheet_guide_desc: "Den ultimative guide til brug af AllChinaBuy spreadsheet til at finde produkter, sammenligne priser og foretage velinformerede køb i 2026.",
  article_allchinabuy_review: "AllChinaBuy Anmeldelse 2026",
  article_allchinabuy_review_desc: "Omfattende anmeldelse der dækker funktioner, gebyrer, forsendelsesmuligheder, kundesupport og reelle brugeroplevelser.",
  article_shipping_cost: "Guide til AllChinaBuy forsendelsesomkostninger",
  article_shipping_cost_desc: "Komplet gennemgang af forsendelsesmetoder, omkostninger efter land og tips til at reducere dine forsendelsesomkostninger.",
  article_allchinabuy_coupon: "AllChinaBuy kuponer og rabatkoder",
  article_allchinabuy_coupon_desc: "Aktuelle kuponer, rabatkoder og pengebesparende tips for AllChinaBuy-købere.",
  article_allchinabuy_vs: "AllChinaBuy vs konkurrenter",
  article_allchinabuy_vs_desc: "Detaljeret sammenligning af AllChinaBuy med Superbuy, CSSBuy, Sugargoo og Pandabuy.",
  article_allchinabuy_legit: "Er AllChinaBuy legitim?",
  article_allchinabuy_legit_desc: "Sikkerhedsguide der dækker betalingssikkerhed, QC-processer, lageropbevaring og hvordan man undgår svindel.",
  article_allchinabuy_qc: "AllChinaBuy QC-guide",
  article_allchinabuy_qc_desc: "Sådan bruger du AllChinaBuy's kvalitetskontroltjeneste til at inspicere dine varer før international forsendelse.",
  article_allchinabuy_warehouse: "AllChinaBuy lagerguide",
  article_allchinabuy_warehouse_desc: "Forstå lageropbevaring, inspektion og konsolideringstjenester hos AllChinaBuy.",

  // CTA Section
  cta_title: "Klar til at udforske AllChinaBuy?",
  cta_subtitle: "Research først. Sammenlign muligheder. Træf bedre informerede beslutninger.",
  cta_button: "AllChinaBuy Spreadsheet",
  cta_button_secondary: "Køb nu",

  // FAQ Section
  faq_title: "Ofte stillede spørgsmål",
  faq_1_q: "Hvad er AllChinaBuy Spreadsheet?",
  faq_1_a: "AllChinaBuy Spreadsheet er en kurateret samling af produktlinks, priser og sælgerinformation organiseret i et nemt at bruge format. Det hjælper købere med at finde de bedste tilbud på sko, tøj, tilbehør og mere fra kinesiske shoppingplatforme.",
  faq_2_q: "Er AllChinaBuy sikkert at bruge?",
  faq_2_a: "AllChinaBuy implementerer standard sikkerhedsforanstaltninger inklusive krypterede betalinger, lagerkvalitetskontrol og køberbeskyttelsespolitikker. Som med enhver international shoppingtjeneste anbefaler vi dog at undersøge sælgere og bruge QC-tjenesten (kvalitetskontrol) før international forsendelse.",
  faq_3_q: "Hvor meget koster AllChinaBuy forsendelse?",
  faq_3_a: "Forsendelsesomkostninger varierer efter destinationsland, pakkevægt og forsendelsesmetode. AllChinaBuy tilbyder flere forsendelseslinjer inklusive EMS, DHL, FedEx og budgetmuligheder. Brug vores forsendelsesberegner-guide til at estimere omkostninger for din specifikke ordre.",
  faq_4_q: "Tilbyder AllChinaBuy kuponer eller rabatkoder?",
  faq_4_a: "Ja, AllChinaBuy leverer regelmæssigt kuponer og promoveringsrabatkoder til nye og eksisterende kunder. Tjek vores kuponguide for aktive koder og pengebesparende strategier.",
  faq_5_q: "Hvordan sammenligner AllChinaBuy sig med andre shoppingagenter?",
  faq_5_a: "AllChinaBuy tilbyder konkurrencedygtige forsendelsespriser, en brugervenlig grænseflade og omfattende spreadsheet-ressourcer. Sammenlignet med Superbuy, CSSBuy og Sugargoo skiller AllChinaBuy sig ud med sine organiserede produktspreadsheets og simple gebyrstruktur. Læs vores detaljerede sammenligningsguider for mere information.",
  faq_6_q: "Hvilke lande sender AllChinaBuy til?",
  faq_6_a: "AllChinaBuy sender til de fleste lande verden over inklusive USA, Storbritannien, Canada, Tyskland, Frankrig, Danmark, Australien og Europa. Forsendelsestider og omkostninger varierer efter destination.",
  faq_7_q: "Kan jeg få refusion, hvis min ordre er forkert?",
  faq_7_a: "AllChinaBuy tilbyder refusions- og returmuligheder afhængigt af sælgerens politik og ordrens stadie. Varer der ikke er sendt fra lageret kan typisk returneres. Når de først er sendt internationalt, bliver returneringer mere komplekse og kan indebære ekstra gebyrer.",
  faq_8_q: "Hvordan bruger jeg AllChinaBuy spreadsheet?",
  faq_8_a: "At bruge AllChinaBuy spreadsheet er enkelt: gennemse kategorier, klik på produktlinks for at se varer, tilføj ønskede produkter til din kurv og fortsæt med købsprocessen. Vores komplette guide giver trin-for-trin instruktioner med skærmbilleder.",

  // Footer
  footer_title: "AllChinaBuy Spreadsheet",
  footer_desc: "Din betroede ressource til AllChinaBuy produktforskning, anmeldelser og shoppingguides. Vi hjælper dig med at træffe informerede beslutninger, når du handler fra Kina.",
  footer_links: "Hurtige links",
  footer_resources: "Ressourcer",
  footer_legal: "Juridisk",
  footer_privacy: "Privatlivspolitik",
  footer_terms: "Servicevilkår",
  footer_disclaimer: "Disclaimer",
  footer_contact: "Kontakt os",
  footer_copyright: "AllChinaBuy Spreadsheet. Alle rettigheder forbeholdes. Dette er en uafhængig informativ ressource og er ikke tilknyttet eller drevet af AllChinaBuy, medmindre det udtrykkeligt er angivet.",

  // Article Page
  article_back_home: "Tilbage til forsiden",
  article_toc: "Indholdsfortegnelse",
  article_last_updated: "Senest opdateret",
  article_author: "Forfatter",
  article_reading_time: "Læsetid",
  article_related: "Relaterede artikler",
  article_faq_title: "Ofte stillede spørgsmål",
  article_share: "Del denne guide",
  article_cta_text: "Klar til at begynde at handle med AllChinaBuy?",
  article_cta_button: "Udforsk AllChinaBuy Spreadsheet",
  article_cta_button_buy: "Køb nu",

  // About Page
  about_title: "Om AllChinaBuy Spreadsheet",
  about_desc: "Vi er et uafhængigt ressourcecenter dedikeret til at hjælpe købere med at navigere i verden af kinesiske shoppingagenter. Vores mission er at give transparent, præcis og nyttig information om AllChinaBuy og relaterede tjenester.",
  about_mission: "Vores mission",
  about_mission_desc: "At styrke internationale købere med den viden og de værktøjer, der er nødvendige for at træffe selvsikre købsbeslutninger, når de bruger AllChinaBuy og lignende shoppingagent-tjenester.",
  about_vision: "Vores vision",
  about_vision_desc: "At blive den mest betroede uafhængige ressource for AllChinaBuy-købere over hele verden, der dækker alle aspekter af shoppingoplevelsen fra produktforskning til levering.",
  about_values: "Vores værdier",
  about_values_transparency: "Transparens i alle vores anmeldelser og sammenligninger",
  about_values_accuracy: "Præcis, opdateret information",
  about_values_independence: "Uafhængighed fra enhver shoppingagentvirksomhed",
  about_values_helpfulness: "Nyttigt indhold, der løser reelle problemer",

  // Contact Page
  contact_title: "Kontakt os",
  contact_desc: "Har du spørgsmål om AllChinaBuy? Vi er her for at hjælpe. Kontakt vores team for forespørgsler, forslag eller samarbejdsmuligheder.",
  contact_form_name: "Dit navn",
  contact_form_email: "E-mailadresse",
  contact_form_subject: "Emne",
  contact_form_message: "Besked",
  contact_form_submit: "Send besked",
  contact_info: "Kontaktoplysninger",
  contact_response: "Vi svarer typisk inden for 24-48 timer.",

  // Breadcrumb
  breadcrumb_home: "Hjem",
  breadcrumb_article: "Artikel",
  breadcrumb_about: "Om",
  breadcrumb_contact: "Kontakt",
};